export const FETCH_BRANCH_REQUEST = 'FETCH_BRANCH_REQUEST';
export const FETCH_BRANCH_SUCCESS = 'FETCH_BRANCH_SUCCESS';
export const FETCH_BRANCH_FAILURE = 'FETCH_BRANCH_FAILURE';

export const FETCH_BRANCH_AGB_REQUEST = 'FETCH_BRANCH_AGB_REQUEST';
export const FETCH_BRANCH_AGB_SUCCESS = 'FETCH_BRANCH_AGB_SUCCESS';
export const FETCH_BRANCH_AGB_FAILURE = 'FETCH_BRANCH_AGB_FAILURE';

export const SUBMIT_BRANCH_REQUEST = 'SUBMIT_BRANCH_REQUEST';
export const SUBMIT_BRANCH_SUCCESS = 'SUBMIT_BRANCH_SUCCESS';
export const SUBMIT_BRANCH_FAILURE = 'SUBMIT_BRANCH_FAILURE';

export const SUBMIT_BRANCH_AGB_REQUEST = 'SUBMIT_BRANCH_AGB_REQUEST';
export const SUBMIT_BRANCH_AGB_SUCCESS = 'SUBMIT_BRANCH_AGB_SUCCESS';
export const SUBMIT_BRANCH_AGB_FAILURE = 'SUBMIT_BRANCH_AGB_FAILURE';

export const USE_HEYCAR_AGB_REQUEST = 'USE_HEYCAR_AGB_REQUEST';
export const USE_HEYCAR_AGB_SUCCESS = 'USE_HEYCAR_AGB_SUCCESS';
export const USE_HEYCAR_AGB_FAILURE = 'USE_HEYCAR_AGB_FAILURE';

export const SUBMIT_BRANCH_SEPA_MANDATE_REQUEST =
  'SUBMIT_BRANCH_SEPA_MANDATE_REQUEST';
export const SUBMIT_BRANCH_SEPA_MANDATE_SUCCESS =
  'SUBMIT_BRANCH_SEPA_MANDATE_SUCCESS';
export const SUBMIT_BRANCH_SEPA_MANDATE_FAILURE =
  'SUBMIT_BRANCH_SEPA_MANDATE_FAILURE';

export const SET_BRANCH_PAYMENT_METHOD_STEP = 'SET_PAYMENT_METHOD_STEP';
export const UPDATE_BRANCH = 'UPDATE_BRANCH';
export const RESET_BRANCH = 'RESET_BRANCH';

export const UPDATE_BRANCH_SEPA_MANDATE = 'UPDATE_BRANCH_SEPA_MANDATE';
export const RESET_BRANCH_SEPA_MANDATE = 'RESET_BRANCH_SEPA_MANDATE';
export const UPDATE_BRANCH_SEPA_TERMS_ACCEPTED =
  'UPDATE_BRANCH_SEPA_TERMS_ACCEPTED';
export const UPDATE_ALL_BRANCHES_SEPAS = 'UPDATE_ALL_BRANCHES_SEPAS';

export const UPDATE_OPENING_TIMES_BLOCK = 'UPDATE_OPENING_TIMES_BLOCK';
export const UPDATE_SALES_BRANDS = 'UPDATE_SALES_BRANDS';
export const UPDATE_TSP_PERMISSION = 'UPDATE_TSP_PERMISSION';

export const GET_TSPLIST_REQUEST = 'GET_TSPLIST_REQUEST';
export const GET_TSPLIST_SUCCESS = 'GET_TSPLIST_SUCCESS';
export const GET_TSPLIST_FAILURE = 'GET_TSPLIST_FAILURE';

export const GET_SEPA_MANDATES_REQUEST = 'GET_SEPA_MANDATES_REQUEST';
export const GET_SEPA_MANDATES_SUCCESS = 'GET_SEPA_MANDATES_SUCCESS';
export const GET_SEPA_MANDATES_FAILURE = 'GET_SEPA_MANDATES_FAILURE';

export const CHECK_BRANCH_PHONE_REQUEST = 'CHECK_BRANCH_PHONE_REQUEST';
export const CHECK_BRANCH_PHONE_SUCCESS = 'CHECK_BRANCH_PHONE_SUCCESS';
export const CHECK_BRANCH_PHONE_FAILURE = 'CHECK_BRANCH_PHONE_FAILURE';

export const CHECK_BRANCH_ZIP_REQUEST = 'CHECK_BRANCH_ZIP_REQUEST';
export const CHECK_BRANCH_ZIP_SUCCESS = 'CHECK_BRANCH_ZIP_SUCCESS';
export const CHECK_BRANCH_ZIP_FAILURE = 'CHECK_BRANCH_ZIP_FAILURE';

export const VALIDATE_FREESPEE_PHONE_ADDRESS_REQUEST =
  'VALIDATE_FREESPEE_PHONE_ADDRESS_REQUEST';
export const VALIDATE_FREESPEE_PHONE_ADDRESS_SUCCESS =
  'VALIDATE_FREESPEE_PHONE_ADDRESS_SUCCESS';
export const VALIDATE_FREESPEE_PHONE_ADDRESS_FAILURE =
  'VALIDATE_FREESPEE_PHONE_ADDRESS_FAILURE';
